/* Born Forged — progressive reveal on scroll (v3: cascade + product image page transition).
   Content stays visible without JS; reduced motion shows everything at once. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STEP = 90, MAX_STEPS = 5;

  function reveal(el, delay) {
    if (delay) el.style.setProperty('--bf-delay', delay + 'ms');
    el.classList.add('is-in');
    if (delay) {
      setTimeout(function () { el.style.removeProperty('--bf-delay'); }, delay + 1400);
    }
  }

  function init(root) {
    var els = (root || document).querySelectorAll('.bf-reveal:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      var batch = [];
      entries.forEach(function (entry) { if (entry.isIntersecting) batch.push(entry.target); });
      batch.sort(function (a, b) {
        return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
      });
      batch.forEach(function (el, i) {
        io.unobserve(el);
        reveal(el, Math.min(i, MAX_STEPS) * STEP);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Product card -> product page: hand the card photo to Horizon's native
     "product-image-transition" (view-transitions.js). Plain navigation is untouched. */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest && e.target.closest('.bf-card a[href]');
    if (!link) return;
    var media = link.closest('.bf-card').querySelector('.bf-card__media');
    if (!media) return;
    media.setAttribute('data-view-transition-type', 'product-image-transition');
    media.setAttribute('data-view-transition-triggered', '');
  });
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.bf-card__media[data-view-transition-triggered]').forEach(function (el) {
      el.removeAttribute('data-view-transition-triggered');
      el.removeAttribute('data-view-transition-type');
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
